import { Accordion } from "react-bootstrap"
import "./Info.scss"
import "./Faqs.scss"
import { Link } from "react-router-dom"
import { useEffect } from "react"

export default function Faqs (){
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  return (
    <div className="info-pages faqs">
      <div className="info-header"></div>
      <div className="page-info-content">
        <div className="page-info-header">
          <div className="title">Preguntas Frecuentes</div>
          <div className="subtitle">Nuestra filosofía es hacer una diferencia, brindándoles a nuestros clientes un valor agregado, tanto en la variedad como en la calidad de los productos que ofrecemos, el servicio y la atención.</div>
        </div>
        <div className="page-info-data">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>¿Qué medio de pago puedo utilizar?</Accordion.Header>
              <Accordion.Body>
                Contamos con 4 medios de pago:
                <ol>
                  <li>Transferencia bancaria</li>
                  <li>Depósito bancario<br/>Para los mismos puedes acceder a la información de nuestras cuentas haciendo click <Link to={'/cbu'}>aquí</Link>.</li>
                  <li>Tarjeta de débito o crédito únicamente acercándote a nuestro showroom en calle Zapiola 400.</li>
                  <li>Cuenta Corriente (sujeta a aprobación) si quiere acceder a esta opción deberá comunicarse con su ejecutivo de cuenta.</li>
                </ol>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>¿Hay un mínimo de compra?</Accordion.Header>
              <Accordion.Body>
                Sí, tenemos un mínimo de compra de $300.000,00. En caso de que esta sufra un cambio se mostrará en la página.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>¿Cuál es el consto del envío?</Accordion.Header>
              <Accordion.Body>
                El costo de este correrá por cuenta del cliente, se podrá abonar al recibir el pedido.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>¿Puedo pasar a retirar mi pedido?</Accordion.Header>
              <Accordion.Body>
                Sí, podes acercarte y retirar tu pedido en nuestro showroom ubicado en calle Zapiola 400 (Bahía Blanca, Buenos Aires).
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>¿Cómo se realizan los envíos?</Accordion.Header>
              <Accordion.Body>
                Realizamos envíos a todo el país, el cliente podrá elegir el transporte de su preferencia.<br/>Los envíos dentro de la ciudad de Bahía Blanca no tienen costo.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>¿Qué demora tiene el envío?</Accordion.Header>
              <Accordion.Body>
                La demora estimada para la entrega de un pedido es de 24 a 48hs, a excepción de fechas de mucha demanda como navidad o el día del niño, donde puede tener una mayor demora.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>¿Cómo comprar en Libreria del Colegio?</Accordion.Header>
              <Accordion.Body>
                <p>Al ingresar en nuestra página web vas a encontrar distintos rubros y artículos con los que trabajamos. Antes de comenzar a cargar los artículos a tu carrito deberás crearte un usuario para poder iniciar sesión (ingresá <Link to={'/como-operar'}>aquí</Link> para conocer los pasos para crear tu usuario). Podés elegir lo que te guste y agregarlo a tu carrito de compras.</p>
                <p>Una vez que hayas seleccionado todo lo que quieras, deberás ingresar tus datos para poder realizar el pedido. El mismo estará sujeto a disponibilidad de stock. Nos contactaremos con vos una vez confirmado el stock de todo tu pedido.</p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>¿Los precios que estan publicados tienen IVA?</Accordion.Header>
              <Accordion.Body>
                Todos los precios publicados son sin IVA. Una vez que cargues tus productos en el carrito el mismo se descriminará abajo del producto.<br/>
                Cabe recordar que los libros se encuentran exentos de IVA por lo que el precio publicado es su precio final.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  )
}